import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { createGlobalStyle } from 'styled-components';
import man_draw from '../images/index/man_draw.svg';
import RegisterSection from '../components/RegisterSection';
import { isUserLoggedIn } from '../services/user-credentials';
import { Box, Image, Text } from 'rebass';
import { ApolloProvider, useQuery, gql } from '@apollo/client';
import client from '../utils/apollo-config';
import AnalyticsFactory from "../analytics/analytics";
import { USER_OPEN_APP } from '../analytics/events';


const EXCHANGE_RATES = gql`
  query GetExchangeRates {
    rates(currency: "USD") {
      currency
      rate
    }
  }
`;

const GlobalStyle = createGlobalStyle`
  html,
  body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    background-color: #FFECC0;
    font-family: "Montserrat";
  }
`;

export function Index() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AnalyticsFactory.getInstance().logEvent({ name: USER_OPEN_APP });
    validateUserCredentials();
  },[]);

  const validateUserCredentials = () => {
    if (isUserLoggedIn()) {
      navigate('/app/');
    } else {
      setLoading(false);
    }
  };

  return (
    //<ApolloProvider client={client}>
    loading ? null : (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <GlobalStyle />
        <Box height={'60vh'}>
          <RegisterSection />
        </Box>
        <Box bg={'#FFECC0'} height={'40vh'}>
          <Text
            sx={{
              p: '2',
              textAlign: 'center',
              color: '#5F5F5F',
              fontWeight: 'bold',
              fontSize: '19px',
              fontStyle: 'normal',
            }}
          >
            Com a Qista...
          </Text>
          <Box>
            <Text
              sx={{
                px: '2',
                textAlign: 'center',
                color: '#5F5F5F',
                fontWeight: 'bold',
                fontSize: '14px',
                fontStyle: 'normal',
              }}
            >
              você tem acesso a vantagens exclusivas e ainda participa da
              Campanha Pontualidade Premiada
            </Text>
          </Box>
          <Box
            mt={3}
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Image src={man_draw} />
          </Box>
        </Box>
      </Box>
    )

    //</ApolloProvider>
  );
}

export default Index;
